import { CartIconHeader } from 'src/components/icons/CartIconHeader'
import { RenderClient } from 'src/components/RenderClient'
import { useCart } from 'src/sdk/cart/useCart'
import { useCartToggleButton } from 'src/sdk/cart/useCartToggleButton'

export const CartInfo = () => {
  const { totalItems, total } = useCart()
  const btnProps = useCartToggleButton()

  return (
    <>
      <div className="relative">
        <button
          className="flex flex-row items-center gap-3 text-xs font-normal tracking-[0.048px] !leading-[130%] focus:outline-none bg-yellow cursor-pointer p-0"
          {...btnProps}
        >
          <span className="block flex-shrink-0 w-8 h-8 p-1 rounded-full border border-solid border-yellow-200 relative">
            <CartIconHeader color={'black'} />
            <RenderClient>
              <span className="flex items-center justify-center absolute top-0 right-0 translate-x-[50%] translate-y-[-50%] min-w-[16px] min-h-[16px] rounded-full bg-red-600 text-white text-[10px] tracking-[0.15px] font-medium">
                {totalItems}
              </span>
            </RenderClient>
          </span>
          <span className="hidden 2xl:block text-left">
            <span className="block text-xs !leading-[130%] tracking-[0.048px] font-normal">
              Il tuo carrello
            </span>
            <RenderClient>
              <span className="block text-sm !leading-[130%] tracking-[0.035px] font-semibold">
                € {total ? total.toFixed(2) : 0}
              </span>
            </RenderClient>
          </span>
        </button>
      </div>
    </>
  )
}
